import React from 'react';
import PropTypes from 'prop-types';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMUserResource from 'resources/SMUserResource';
import SMFormSubmitButton from 'components/dashboard/form/SMFormSubmitButton';

class SMUnapprovedReservationRejectView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.formDidSubmit = this.formDidSubmit.bind(this);
  }

  componentDidMount() {
    $(this.refs.listContainer).find("input[type=radio]").on("change", function(e){
      $(".js-form-radio-select_message").hide();
      let $message = $(this.refs[e.currentTarget.id]);
      if ($message.length) {
        $message.fadeIn();
      }
    }.bind(this));
  }

  formDidSubmit(e) {
    e.preventDefault();
    let formData = new FormData(e.currentTarget);
    $(this.refs.listContainer).startLoading();
    if (this.props.isOwner) {
      SMOwnerResource.rejectReservation(this.props.reservation, formData, function (data, error, xhr) {
        $(this.refs.listContainer).stopLoading();

        if (!error) {
          if (this.props.delegate && typeof this.props.delegate.unapprovedReservationDidReject == 'function') {
            this.props.delegate.unapprovedReservationDidReject(data, xhr);
          }
        } else {
          if (this.props.delegate && typeof this.props.delegate.unapprovedReservationDidFailToReject == 'function') {
            this.props.delegate.unapprovedReservationDidFailToReject(error, xhr);
          }
        }
      }.bind(this));
    } else {
      SMUserResource.rejectReservation(this.props.reservation, formData, function (data, error, xhr) {
        $(this.refs.listContainer).stopLoading();

        if (!error) {
          if (this.props.delegate && typeof this.props.delegate.unapprovedReservationDidReject == 'function') {
            this.props.delegate.unapprovedReservationDidReject(data, xhr);
          }
        } else {
          if (this.props.delegate && typeof this.props.delegate.unapprovedReservationDidFailToReject == 'function') {
            this.props.delegate.unapprovedReservationDidFailToReject(error, xhr);
          }
        }
      }.bind(this));
    }
  }
  
  render() {
    {
      const reservation = this.props.reservation;
      return (
        <div ref="listContainer" className="form-casette maincol-lightbox__form">
          <h2 className="dashboard-title mb30 ta-c"
              dangerouslySetInnerHTML={{__html: I18n.t("dashboard.text_000049")}} />
          <form onSubmit={this.formDidSubmit}>
            <div className="ta-c mb30">
              <SMFormSubmitButton
                title={I18n.t("dashboard.label_000212")}
                options={{className: "button-gray maincol-buttonarea__button"}} />
            </div>
          </form>
        </div>
      );
    }

  }
}

SMUnapprovedReservationRejectView.propTypes = {
  reservation: PropTypes.object.isRequired,
  isOwner: PropTypes.bool.isRequired,
  delegate: PropTypes.object
};
export default SMUnapprovedReservationRejectView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMUnapprovedReservationRejectView.jsx